import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/lib/date-picker/generatePicker';
import 'antd/lib/date-picker/style/index';

/**
 *  Use this component in future instead of directly using from antd . we are using antd 4 version which default support moment js which is deprecated  library .With this custom configuration we have switch to dayjs library . 
 * 
 * Configuration link for this custom  file   reference you can find below link 
 * antd official doc ref
 * https://4x.ant.design/docs/react/replace-moment#DatePicker
 * 
 * https://github.com/xiaohuoni/antd4-generate-picker/tree/master/antd-demo
 * 
 * You can find different component in component folder
 * src-component 
 * 
 * 
 * In Future if we upgrade antd 5 you can directly use component from ants import.
 * 
 */
const DatePicker = generatePicker(dayjsGenerateConfig);

export default DatePicker;